<template>
  <div id="scanner-container">
    <canvas class="drawingBuffer" style="position: absolute; width: 80%"/>
    <video preload="auto" style="width: 80%"/>
  </div>
</template>

<script>

import Quagga from '@ericblade/quagga2'

export default {
  name: "BarcodeScanner",
  methods: {
    errorMean(result) {
      let errorCodes = result.codeResult.decodedCodes.filter(it => it.error)
      return errorCodes
        .map(it => it.error)
        .reduce((a, b) => a + b, 0) / errorCodes.length
    }
  },
  mounted() {
    Quagga.init({
      frequency: 10,
      inputStream: {
        target: document.querySelector('#scanner-container')
      },
      decoder: {
        readers: ["ean_reader"]
      },
    }, err => {
      if (err) {
        return
      }
      Quagga.start();
    });

    Quagga.onProcessed(result => {
      let drawingCtx = Quagga.canvas.ctx.overlay
      let drawingCanvas = Quagga.canvas.dom.overlay

      if (result) {
        if (result.boxes) {
          let width = parseInt(drawingCanvas.getAttribute("width"));
          let height = parseInt(drawingCanvas.getAttribute("height"));
          drawingCtx.clearRect(0, 0, width, height);
          result.boxes
            .filter(box => box !== result.box )
            .forEach(box => {
              Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
            });
        }

        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
        }

        if (result.codeResult && result.codeResult.code) {
          let mean = this.errorMean(result)
          if (mean < 0.10) {
            this.$emit('barcode-read', { barcode: result.codeResult.code, mean })
          }

          Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
        }
      }
    });
  }
}
</script>

<style scoped>

</style>
